import { render } from "./App.vue?vue&type=template&id=00d7beb7&scoped=true&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=00d7beb7&lang=scss&scoped=true"
import "./App.vue?vue&type=style&index=1&id=00d7beb7&lang=scss"

import exportComponent from "/home/vsts/work/1/s/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00d7beb7"]])

export default __exports__